<!-- <app-navbar-style-one></app-navbar-style-one> -->
<div class="newNavBar">
    <div class="goBackBtn text-end pe-4">
        <a (click)="goBack()"><i style="font-size: 25px;color: #fff !important;" class="fa fa-arrow-left"></i></a>
    </div>
</div>
<div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>طلباتي</h3>
        </div>
    </div>
</div>
<div class="alert alert-success text-center" *ngIf="showSuccess" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{successMsg}}
</div>

<div class="alert alert-danger text-center" *ngIf="showError" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{errorMsg}}
</div>
<section class="checkout-area pt-100 pb-70">
    <div class="container">
        <div class="address-container">
            <h3>جميع طلباتي</h3>
            <div class="address-list">
                <div *ngFor="let order of orders" class="order-card">
                    <a class="w-100" href="order-details/{{order.orderId}}">
                        <div class="order-header">
                            <img [src]="order.vendor.avatar" (error)="handleImageError($event)" alt="Vendor Logo" class="vendor-avatar">
                            <div class="vendor-info">
                              <h3>{{ order.vendor.name }}</h3>
                              <span class="order-id">#{{ order.orderId }}</span>
                            </div>
                            <div class="order-status" [ngClass]="{
                              'status-ordered': order.status != 'canceled',
                              'status-canceled': order.status === 'canceled'
                            }">
                              {{ order.status | titlecase }}
                            </div>
                        </div>
                        
                        <div class="order-details">
                            <div class="order-time">
                              <i class="fas fa-calendar-alt"></i>
                              <span>{{ order.orderedAt | date:'dd MMM yyyy' }}</span>
                              <i class="fas fa-clock"></i>
                              <span>{{ order.orderedAt | date:'hh:mm a' }}</span>
                            </div>
                        </div>
                    </a>
                  
                    <div class="order-actions">
                      <!-- <button *ngIf="order.status !== 'canceled'" 
                              (click)="cancelOrder(order.orderId)"
                              class="btn-action btn-cancel">
                        <i class="fas fa-times-circle"></i> إلغاء
                      </button> -->
                      <button (click)="reorder(order.orderId)"
                              class="btn-action btn-reorder">
                        <i class="fas fa-redo"></i> أعد الطلب
                      </button>
                      <button (click)="deleteOrder(order.orderId)"
                              class="btn-action btn-delete">
                        <i class="fas fa-trash-alt"></i> حذف
                      </button>
                    </div>
                </div>
                <div class="alert alert-danger" *ngIf="ordersCounter == 0">
                    <p>لا يوجد طلبات حتي الان</p>
                </div>
            </div>
        </div>

        
    </div>
</section>

<!-- <app-footer-style-two></app-footer-style-two> -->